import React from 'react';
import { cn } from '../../../classname';
import { Colors } from '../../../extensions';
import { i18n } from '../../../i18n/menubar';
import { icons } from '../../config/icons';
import { ToolbarButtonWithPopupMenu } from '../ToolbarButtonWithPopupMenu';
import './ToolbarColors.css';
const b = cn('toolbar-colors');
const textColorIcon = icons.textColor;
export const ToolbarColors = (props) => {
    var _a;
    const { exec, onClick, enable, currentColor, withDefault } = props;
    const isDefault = currentColor === undefined;
    const onItemClick = (color) => () => {
        // do not exec when current color is default and clicked to default item
        if (!(isDefault && color === ''))
            exec(color);
        onClick === null || onClick === void 0 ? void 0 : onClick('colorify', { color: color === '' ? 'default' : color });
    };
    const items = [
        Colors.Gray,
        Colors.Yellow,
        Colors.Orange,
        Colors.Red,
        Colors.Green,
        Colors.Blue,
        Colors.Violet,
    ].map((color) => {
        var _a;
        return ({
            id: color,
            icon: textColorIcon.data,
            iconSize: (_a = textColorIcon.size) !== null && _a !== void 0 ? _a : 16,
            text: i18n(`colorify__color_${color}`),
            iconClassname: b('item-icon', { color }),
            action: {
                run: onItemClick(color),
                isEnable: () => Boolean(enable),
                isActive: () => color === currentColor,
                meta() { },
            },
            group: i18n(`colorify__group_text`),
        });
    });
    if (withDefault) {
        items.unshift({
            id: 'default',
            icon: textColorIcon.data,
            iconSize: (_a = textColorIcon.size) !== null && _a !== void 0 ? _a : 16,
            text: i18n(`colorify__color_default`),
            iconClassname: b('item-icon', { color: 'default' }),
            group: i18n(`colorify__group_text`),
            ignoreActive: true,
            action: {
                run: onItemClick(''),
                isEnable: () => Boolean(enable),
                isActive: () => isDefault,
                meta() { },
            },
        });
    }
    return (React.createElement(ToolbarButtonWithPopupMenu, Object.assign({}, props, { title: i18n('colorify'), menuItems: items, icon: textColorIcon })));
};
